import { createSelector } from 'reselect';

// sf_12127_ssdc_paid_landing_refresh
export default createSelector(
	(state) => state.phone,
	(phone) => ({
		phone: phone.headerPhone,
	}),
);
